import CONSTANTS from '../../constants';

const state = {
	errors: {},
};

const mutations = {
	[CONSTANTS.MUTATIONS.PUSH_ERRORS](state, errorsObject) {
		console.log('MUTATIONS PUSH ERRORS');
		state.errors = errorsObject;
	},
	[CONSTANTS.MUTATIONS.CLEAR_ERRORS](state) {
		console.log('MUTATIONS CLEAR ERRORS');
		state.errors = {};
	}
};

const getters = {
	getErrors: (state) => (fieldName) => {
		return state.errors[fieldName] || [];
	},
	hasErrors: (state) => (fieldName) => {
		return state.errors[fieldName]? (state.errors[fieldName].length > 0): false;
	}
};

export default {
	namespaced: true,
	state,
	mutations,
	getters,
}


// WEBPACK FOOTER //
// ./resources/js/store/modules/formErrors.js